import { isIosPlatform } from '@lighthouse/tools'
import { LoadingOverlay, Portal } from '@mantine/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { UploadDropZone, type UseUploadFileSParameter } from '../../UploadManage'
import { SELECT_FILE_UPLOAD_OPTIONS, SELECT_VIDEO_UPLOAD_OPTIONS } from '../constants'
import * as CM from '../WithoutPopperFileUploader/styles'

interface FileAddProps {
    uploadyOptions: Pick<UseUploadFileSParameter, 'info' | 'options'>
    disableUpload?: boolean
    uploadFileType?: 'file' | 'video'
    isMobile?: boolean
    accept?: string
    multiple?: boolean
    /** 本次最多上传文件数，超出部分丢弃 */
    maxFileCount?: number
}

const SCxContainer = styled.div`
    width: 100%;

    > *:not(:first-child) > ${CM.Item} {
        border-top: 1px solid var(--color-gray-200);
    }
`

const FileAdd: React.FunctionComponent<FileAddProps> = ({
    uploadyOptions,
    uploadFileType,
    disableUpload,
    isMobile,
    accept: acceptOverride,
    multiple = true,
    maxFileCount
}) => {
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

    const options = uploadFileType === 'video' ? SELECT_VIDEO_UPLOAD_OPTIONS : SELECT_FILE_UPLOAD_OPTIONS
    return (
        <SCxContainer>
            {options.map(({ label, capture, accept }) => {
                const effectiveAccept = acceptOverride ?? accept
                // 注意：禁用逻辑基于“选项本身”的能力，而不是 override 后的 accept。
                // 否则像 AVATAR 这种传入 image/* 会把「本地文件」也误禁用。
                const isUseUpload = !isMobile && accept !== '*'
                const isIos = isIosPlatform()
                if (isIos && capture === 'environment') {
                    return null
                }
                return (
                    <UploadDropZone
                        key={label}
                        capture={capture}
                        disabled={disableUpload || isUseUpload}
                        accept={effectiveAccept}
                        multiple={multiple}
                        maxFileCount={maxFileCount}
                        uploadOptions={uploadyOptions}
                    >
                        <CM.Item>{t(label)}</CM.Item>
                    </UploadDropZone>
                )
            })}
            <Portal>
                <LoadingOverlay visible={loading} />
            </Portal>
        </SCxContainer>
    )
}

export default FileAdd
